import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "gateway/";

class GatewayService {
  getList() {
    return axios.post(ENDPOINT_URL + "list", {}, { headers: authHeader() });
  }

  getGateway(gatewayId) {
    return axios.get(ENDPOINT_URL + gatewayId + "/doors", {
      headers: authHeader(),
    });
  }
}

export default new GatewayService();
